export default "__VITE_ASSET__TUx$0Dxc__"